import { ThemeFont, ThemeMode } from '@prisma/client'

type FontType = {
  label_key: string
  value: ThemeFont
}

export const FONT_VALUES: FontType[] = [
  { label_key: 'components.customizer_bar.sans', value: ThemeFont.sans },
  { label_key: 'components.customizer_bar.serif', value: ThemeFont.serif },
  { label_key: 'components.customizer_bar.mono', value: ThemeFont.mono },
]

type ModeType = {
  label_key: string
  value: ThemeMode
}

export const MODE_VALUES: ModeType[] = [
  {
    label_key: 'components.customizer_bar.light',
    value: ThemeMode.light,
  },
  {
    label_key: 'components.customizer_bar.dark',
    value: ThemeMode.dark,
  },
  {
    label_key: 'components.customizer_bar.color',
    value: ThemeMode.overall,
  },
]
